// extracted by mini-css-extract-plugin
export default {"product":"ProductLabel_product__MzvuB"};